<button
  [type]="type"
  [ngClass]="classes"
  (click)="clickHandler($event)"
  [tabindex]="tabindex"
  [disabled]="disabled"
  [ngbTooltip]="tooltip | translate"
>
  <ng-container *ngIf="frontBadge">
    <img
      *ngIf="isImageBadge; else textBadge"
      [src]="frontBadge"
      alt="Badge"
      class="btn-badge"
    />
    <ng-template #textBadge>
      <div
        class="btn-badge"
        [ngClass]="badgeClasses"
      >
        <span>{{ frontBadge }}</span>
      </div>
    </ng-template>
  </ng-container>
  <i
    [ngClass]="iconClasses"
    *ngIf="icon"
  ></i>
  <span class="text-nowrap">{{ label | translate }}</span>
  <ng-content></ng-content>
</button>
